import { useCallback } from "react";
import { sendMessage } from "utils/webview";
import { trackCapiStandardEvent } from "../analytics/metaCapi";

type Params = {
  user: any;
  isInappWebview?: boolean;
  appVersion: string;
  setMixPanel: () => void;
};

/**
 * 결제 버튼 클릭 시 공통 트래킹 훅
 * 순서: FB → Firebase/Appsflyer → CAPI → Mixpanel
 * - 인앱 환경에서만 FB/Firebase/Appsflyer 전송 (웹은 Mixpanel만)
 */
export default function usePaymentButtonClickTracking({
  user,
  isInappWebview,
  setMixPanel,
}: Params) {
  const trackPaymentClick = useCallback(() => {
    if (isInappWebview && user?.isInsider !== true) {
      // FB event
      sendMessage(
        JSON.stringify({
          event: "send_fb_event",
          params: {
            eventName: "btn_click_payment",
          },
        })
      );

      // Firebase
      sendMessage(
        JSON.stringify({
          event: "send_firebase_analytics_event",
          params: {
            eventName: "begin_checkout",
            eventParams: {
              items: [
                {
                  item_id: "distancing_program",
                  item_name: "distancing_program",
                },
              ],
            },
          },
        })
      );

      if (user?.segmentType === "a") {
        sendMessage(
          JSON.stringify({
            event: "send_firebase_analytics_event",
            params: {
              eventName: "begin_checkout_type_a",
              eventParams: {
                items: [
                  {
                    item_id: "distancing_program",
                    item_name: "distancing_program",
                  },
                ],
              },
            },
          })
        );
      }

      // Appsflyer
      sendMessage(
        JSON.stringify({
          event: "send_appsflyer_event",
          params: {
            eventName: "af_btn_click_payment",
          },
        })
      );

      // CAPI InitiateCheckout
      trackCapiStandardEvent(
        "InitiateCheckout",
        {
          externalId: user?.userId,
          email: user?.email,
        },
        undefined,
        undefined,
        true
      );
    }

    setMixPanel();
  }, [user?.isInsider, user?.segmentType, isInappWebview, setMixPanel]);

  return { trackPaymentClick } as const;
}
